import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class FeedbackErrorService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) { }

  getCustomer(accountManagerEmail) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetCustomersByAccountManagerDDL?accountManagerEmail=${accountManagerEmail}`);
  }
  getCustomerAccountManagerDDL(accountManagerEmail) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetListCustomerAccountManagerDDL?accountManagerEmail=${accountManagerEmail}`);
  }
  //getFileName() {
  //  return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetFileName`);
  //}
  getSUG_HAFRASHA() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetSUG_HAFRASHA`);
  }
  getSUG_KUPA() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetSUG_KUPA`);
  }
  getManagementName() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetManagementName`);
  }
  getMisparMezaeOved() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetMisparMezaeOved`);
  }
  getFeedbackErrorEmployee(sCustomerId, sCustomerAccountManager, sMisparMezaheOved, sSelectedMsgSent, sRowsLimit) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetFeedbackErrorEmployee?customerId=${sCustomerId}&customerAccountManager=${sCustomerAccountManager}&misparMezaheOved=${sMisparMezaheOved}&selectedMsgSent=${sSelectedMsgSent}&rowsLimit=${sRowsLimit}`);
  }
  getFeedbackErrorFile(sCustomerId, sCustomerAccountManager, sSelectedMsgSent, sRowsLimit) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetFeedbackErrorFile?customerId=${sCustomerId}&customerAccountManager=${sCustomerAccountManager}&selectedMsgSent=${sSelectedMsgSent}&rowsLimit=${sRowsLimit}`);
  }
  getFeedbackStatusDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetListFeedbackStatus`);
  }
  getFeedbackStatisesPrecalculated() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetFeedbackStatisesPrecalculated`);
  }

  getFeedbackReport() {
    return this.httpClient.get(`${this.rootUrl}/api/Report/Feedback`);
  }
  getFeedbackErrorCodeDescription(code: any) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetFeedbackErrorCodeDescription?code=${code}`, code);
    //return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/GetFeedbackErrorCodeDescription`);
  }
  getEmp(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/EmployeeDepositApi/GetEmployee?customerId=${customerId}`);
  }
  sendMails(resultTable) {
    return this.httpClient.put(`${this.rootUrl}/api/FeedbackError/SendMails`, resultTable);
  }
  BlockSendToCustomer(identityNumber, state) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/BlockSendToCustomer?identityNumber=${identityNumber}&state=${state}`);
  }
  BlockSendToAccountant(identityNumber, state) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/BlockSendToAccountant?identityNumber=${identityNumber}&state=${state}`);
  }
  BlockSendToAgent(identityNumber, state) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/BlockSendToAgent?identityNumber=${identityNumber}&state=${state}`);
  }
  BlockSendToFundInstitution(identityNumber, state) {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackError/BlockSendToFundInstitution?identityNumber=${identityNumber}&state=${state}`);
  }
  
  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/feedback-error.service.ts